<template>
  <div>
    <app-bar :showtab="false" back>
      <template v-slot:title>{{ edit ? "编辑" : "创建" }}云黑库</template>
    </app-bar>
    <div class="d-flex justify-center">
      <v-card width="500">
        <v-card-title> {{ edit ? "编辑" : "创建" }}云黑库 </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-text-field
              label="云黑库名称"
              :rules="[(v) => !!v || '云黑库名称为空']"
              required
              v-model="name"
              placeholder="请输入云黑库名称"
              color="link"
            ></v-text-field>

            <v-text-field
              label="服务器地址"
              required
              v-model="server"
              :rules="[(v) => !!v || '服务器地址为空']"
              placeholder="例如:127.0.0.1:19132"
              color="link"
            ></v-text-field>
            <v-autocomplete
              :items="['BedrockServer', 'PocketMine-MP', 'Nukkit']"
              placeholder="请输入服务器类型"
              v-model="type"
              label="服务器类型"
              :rules="[(v) => !!v || '云黑库类型为空']"
              color="link"
              required
            ></v-autocomplete>
            <v-radio-group v-model="pub" mandatory row>
              <v-radio label="公开云黑库" color="link" :value="1"></v-radio>
              <v-radio label="私有云黑库" color="link" :value="2"></v-radio>
            </v-radio-group>
            <Vaptcha
              ref="captcha"
              v-model="vaptcha"
              scene="1"
              style="height: 46px"
              type="click"
            ></Vaptcha>
          </v-form>
          <div v-if="!edit" class="d-flex mt-4">
            <v-simple-checkbox
              v-ripple
              color="link"
              v-model="argin"
            ></v-simple-checkbox>
            我已同意&nbsp;
            <a
              target="_blank"
              href="https://wiki.blackbe.work/how_to_use/private_repo.html#%E4%BD%BF%E7%94%A8%E6%9D%A1%E4%BE%8B"
              class="link--text"
              >私有云黑库使用条例</a
            >
          </div>
        </v-card-text>

        <v-card-actions>
          <v-btn
            :disabled="!edit && !argin"
            block
            :dark="!(!edit && !argin)"
            color="link"
            @click="create"
            >{{ edit ? "编辑" : "创建" }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import AppBar from "@/components/common/AppBar/AppBar";
import Vaptcha from "@/components/common/Vaptcha/Vaptcha";
import EventBus from "@/tools/event-bus";
import list from "../../networker/list";
export default {
  components: {
    AppBar,
    Vaptcha,
  },
  data() {
    return {
      captcha: {},
      vaptcha: null,
      name: "",
      server: "",
      type: "",
      pub: 1,
      edit: false,
      uuid: "",
      argin: false,
    };
  },
  async activated() {
    this.$route.params;
    let uuid = this.$route.query.edit;
    // 是否存在edit参数
    if (uuid) {
      this.edit = true;
      this.uuid = uuid;

      // 获取云黑库信息
      let res = await list.getRepInfo(this.uuid);
      if (res.data.success) {
        this.name = res.data.data.name;
        this.server = res.data.data.server;
        this.type = res.data.data.server_type;
        this.pub = res.data.data.type;
      } else {
        this.$router.push("/");
      }
    } else {
      this.edit = false;
      this.$refs.form.reset();
    }
  },
  methods: {
    async create() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      if (!this.validate()) {
        EventBus.$emit("snackbar", {
          text: "请先完成验证",
          color: "error",
        });
        return;
      }
      let res;
      if (this.edit) {
        res = await list.editRep(
          this.uuid,
          this.name,
          this.pub,
          this.server,
          this.type
        );
      } else {
        res = await list.createRep(
          this.name,
          this.pub,
          this.server,
          this.type,
          this.captcha
        );
      }

      if (res.data.success == true) {
        EventBus.$emit("snackbar", {
          text: res.data.message,
          color: "success",
        });
        EventBus.$emit("createRep", res.data);
        this.$router.push("/user/cloud");
      } else {
        EventBus.$emit("snackbar", {
          text: res.data.message,
          color: "error",
        });
      }
      this.captcha = {};
      this.vaptcha = null;
      this.$refs.captcha.vaptcha.reset();
    },
    validate() {
      let c = this.handle_captcha(null, 1);
      if (c) {
        this.captcha = c.captcha;
        return true;
      }
      return false;
      // return this.$refs.from.validate() && c;
    },
    handle_captcha(obj = null, scene = 0) {
      let api_server;
      let token;
      if (obj === null) {
        if (this.vaptcha == null) {
          return null;
        }
        api_server = this.$refs.captcha.vaptcha.config.api_server;
        token = this.vaptcha.token;
      } else {
        api_server = obj.config.api_server;
        token = obj.token;
      }
      let api_server_array = api_server.split(".");
      if (api_server_array[1] !== "vaptcha") {
        return null;
      }
      return {
        captcha: {
          server:this.$refs.captcha.vaptcha.config.server,
          token: token,
          scene: scene,
        },
      };
    },
  },
};
</script>

<style>
</style>